import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import ComissaoItemModal from "./ComissaoItemModal"
import LoadModalWithLabel from "./LoadModalWithLabel"
import {
  InputCustom,
  TextArea,
  InputMaskCustom,
  HttpError,
  Loading,
  SelectCustom
} from "../../components"
import * as ApiHelper from "../../ApiHelper"
import * as constants from "../../constants"
import Util from "../../Util"
import { ToastContainer, ToastMessage } from "react-toastr"
class TermoCircunstanciadoForm extends Component {
  constructor() {
    super()
    this.getFiscais = this.getFiscais.bind(this)
    this.getFiscalWithId = this.getFiscalWithId.bind(this)
    this.onChangeContrato = this.onChangeContrato.bind(this)
    this.onChangeFiscal = this.onChangeFiscal.bind(this)
    this.onChangeGestor = this.onChangeGestor.bind(this)
    this.onChangeComissao = this.onChangeComissao.bind(this)
    this.onChangeNome = this.onChangeNome.bind(this)
    this.onChangeCPF = this.onChangeCPF.bind(this)
    this.addItem = this.addItem.bind(this)
    this.removeItem = this.removeItem.bind(this)
    this.onChangeMatricula = this.onChangeMatricula.bind(this)
    this.onChangeUnidadeLotacao = this.onChangeUnidadeLotacao.bind(this)
    this.onChangeParecer = this.onChangeParecer.bind(this)
    this.onChangeRessalva = this.onChangeRessalva.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.addAlert = this.addAlert.bind(this)
    this.toggleComissaoModal = this.toggleComissaoModal.bind(this)
    this.reloadComissaoItem = this.reloadComissaoItem.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false,
      showForm: false,
      fiscais: [],
      fiscal: "",
      contratos: [{ value: null, label: "" }],
      contrato: "",
      tipoComissao: "",
      parecer: "",
      ressalva: "",
      editingItemID: "",
      showComissaoModal: false,
      comissaoContrato: [
        {
          nome: "",
          cpf: "",
          matricula: "",
          unidadeLotacao: ""
        }
      ],
      currentComissao: [],
      comissaoError: [
        {
          nome: "",
          cpf: "",
          matricula: "",
          unidadeLotacao: ""
        }
      ]
    }
    this.showSucessMessage = this.showSucessMessage.bind(this)
    this.toastFactory = React.createFactory(ToastMessage.animation)
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  showSucessMessage() {
    var message = ""
    var title = "Sucesso"
    if (this.props.isEditing) {
      message = "Termo circunstanciado atualizado com sucesso"
    } else {
      message = "Termo circunstanciado cadastrado com sucesso"
    }
    this.container.success(title, message, {
      timeOut: 2000,
      extendedTimeOut: 3000
    })
  }
  showErrorMessage() {
    this.container.error(
      "Ocorreram erros",
      "Verifique os dados e tente novamente",
      {
        timeOut: 2000,
        extendedTimeOut: 3000
      }
    )
  }
  componentWillMount() {
    if (this.props.isEditing) {
      this.getInitialFields()
    } else {
      this.getFiscais()
    }
  }
  getInitialFields() {
    ApiHelper.getTermoEdit(this.props.match.params.id, (data, error) => {
      if (data) {
        this.fillFields(data.termo)
        this.setState(
          {
            fiscais: data.fiscais,
            comissaoContrato: [],
            showForm: true
          },
          () => {
            var fiscalID = data.termo.contrato.fiscal_id
            var contratos = this.getFiscalWithId(fiscalID).contratos
            this.setState(
              {
                contratos: Util.mapContratos(contratos),
                fiscal: fiscalID,
                currentComissao: data.comissao
              },
              () => {
                window.scrollTo(0, 0)
              }
            )
          }
        )
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  fillFields(fields) {
    var currentFields = {
      contrato: fields.num_contrato,
      num_contratoLabel: fields.contrato.num_contrato,
      ressalva: fields.ressalva,
      parecer: fields.parecer,
      tipoComissao: fields.comissao_contrato === 1 ? true : false,
      currentComissao: fields.comissao
    }
    this.setState(currentFields)
  }
  getFiscais() {
    if (!constants.userIsFiscal()) {
      ApiHelper.getFiscais((fiscais, error) => {
        if (fiscais) {
          this.setState({
            fiscais: Util.mapFiscais(fiscais),
            showForm: true
          })
        } else {
          this.setState(
            {
              httpError: error
            },
            () => {
              window.scrollTo(0, 0)
            }
          )
        }
      })
    } else {
      ApiHelper.getMe(() => {
        var contratos = Util.mapContratos(constants.getUserContratos())
        this.setState({
          fiscal: constants.getUserID(),
          showForm: true,
          contratos: contratos
        })
      })
    }
  }
  getFiscalWithId(id) {
    var fiscalFound = ""
    this.state.fiscais.forEach(fiscal => {
      if (fiscal.value === parseInt(id, 10)) fiscalFound = fiscal
    })
    return fiscalFound
  }
  onChangeContrato(event) {
    var newValue = event.target.value
    this.setState({
      num_contratoError: "",
      contrato: newValue
    })
  }
  onChangeFiscal(event) {
    var newValue = event.target.value
    this.setState(
      {
        fiscal_idError: "",
        contrato: "",
        fiscal: newValue
      },
      () => {
        var contratos = this.getFiscalWithId(this.state.fiscal).contratos
        this.setState(
          {
            contratos: contratos ? Util.mapContratos(contratos) : []
          },
          () => {
            if (this.state.contratos.length === 1) {
              this.setState({
                fiscal_idError: "Este fiscal não possui contratos cadastrados"
              })
            }
          }
        )
      }
    )
  }
  onChangeGestor(event) {
    var newValue = event.target.checked
    this.setState({
      tipoComissao: !newValue
    })
  }
  onChangeComissao(event) {
    var newValue = event.target.checked
    this.setState({
      tipoComissao: newValue
    })
  }
  addItem(event) {
    event.preventDefault()
    var oldComissao = this.state.comissaoContrato
    var oldError = this.state.comissaoError
    oldComissao.push({
      nome: "",
      cpf: "",
      matricula: "",
      unidadeLotacao: ""
    })
    oldError.push({
      nome: "",
      cpf: "",
      matricula: "",
      unidadeLotacao: ""
    })
    this.setState({
      comissaoContrato: oldComissao,
      comissaoError: oldError
    })
  }
  removeItem(event) {
    event.preventDefault()
    var oldComissao = this.state.comissaoContrato
    var oldError = this.state.comissaoError
    oldComissao.pop()
    oldError.pop()
    this.setState({
      comissaoContrato: oldComissao,
      comissaoError: oldError
    })
  }
  onChangeCPF(event, id) {
    var newValue = event.target.value
    var oldComissao = this.state.comissaoContrato
    var oldError = this.state.comissaoError
    oldComissao[id].cpf = newValue
    oldError[id].cpf = ""
    this.setState({
      comissaoContrato: oldComissao,
      comissaoError: oldError
    })
  }
  onChangeNome(event, id) {
    var newValue = event.target.value
    var oldComissao = this.state.comissaoContrato
    var oldError = this.state.comissaoError
    oldComissao[id].nome = newValue
    oldError[id].nome = ""
    this.setState({
      comissaoContrato: oldComissao,
      comissaoError: oldError
    })
  }
  onChangeUnidadeLotacao(event, id) {
    var newValue = event.target.value
    var oldComissao = this.state.comissaoContrato
    var oldError = this.state.comissaoError
    oldComissao[id].unidadeLotacao = newValue
    oldError[id].unidade_lotacao = ""
    this.setState({
      comissaoContrato: oldComissao,
      comissaoError: oldError
    })
  }
  onChangeMatricula(event, id) {
    var newValue = event.target.value
    var oldComissao = this.state.comissaoContrato
    var oldError = this.state.comissaoError
    oldComissao[id].matricula = newValue
    oldError[id].matricula = ""
    this.setState({
      comissaoContrato: oldComissao,
      comissaoError: oldError
    })
  }
  onChangeParecer(event) {
    var newValue = event.target.value
    this.setState({
      parecer: newValue,
      parecerError: ""
    })
  }
  onChangeRessalva(event) {
    var newValue = event.target.value
    this.setState({
      ressalva: newValue,
      ressalvaError: ""
    })
  }
  removeComissao(event, index, id) {
    event.preventDefault()
    ApiHelper.deleteComissaoItem(id, error => {
      if (error) {
        this.addAlert("", error.message)
      } else {
        var oldItens = this.state.currentComissao
        oldItens.splice(index, 1)
        this.setState({
          currentComissao: oldItens
        })
      }
    })
  }
  sendForm(event) {
    event.preventDefault()
    var comissao = []
    this.state.comissaoContrato.forEach(comissaoItem => {
      comissao.push({
        nome: comissaoItem.nome,
        cpf: Util.unmaskField(comissaoItem.cpf),
        matricula: comissaoItem.matricula,
        unidade_lotacao: comissaoItem.unidadeLotacao
      })
    })
    var params = {
      num_contrato: this.state.contrato,
      comissao_contrato: this.state.tipoComissao ? 1 : 0,
      parecer: this.state.parecer,
      ressalva: this.state.ressalva,
      comissao: this.state.tipoComissao ? comissao : []
    }
    this.toggleLoadModal()
    if (this.props.isEditing) {
      ApiHelper.updateTermo(this.props.match.params.id, params, error => {
        this.toggleLoadModal()
        if (error) {
          this.showErrorMessage()
          this.handleErrors(error)
        } else {
          this.showSucessMessage()
          Util.sleep(3000).then(() => {
            this.props.callBackTermo()
          })
        }
      })
    } else {
      ApiHelper.sendNewTermoCircunstanciado(params, error => {
        this.toggleLoadModal()
        if (error) {
          this.showErrorMessage()
          this.handleErrors(error)
        } else {
          this.showSucessMessage()
          Util.sleep(3000).then(() => {
            this.props.callBackTermo()
          })
        }
      })
    }
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  toggleComissaoModal(event, index, id) {
    event.preventDefault()
    this.setState({
      editingItemID: id,
      showComissaoModal: !this.state.showComissaoModal
    })
  }
  reloadComissaoItem(value) {
    var id = value.id
    var oldCurrentComissao = this.state.currentComissao
    oldCurrentComissao.forEach((comissao, index) => {
      if (comissao.id === id) {
        oldCurrentComissao[index] = value
      }
    })
    this.setState({
      currentComissao: oldCurrentComissao,
      showComissaoModal: !this.state.showComissaoModal
    })
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.erros
    var errorsState = {}
    var comissaoError = this.state.comissaoError
    for (var key in errorsValue) {
      if (key.includes("comissao.")) {
        var index = key.split("comissao.").join("")
        if (index.includes(".cpf")) {
          index = index.split(".cpf").join("")
          comissaoError[index].cpf = errorsValue[key][0]
        }
        if (index.includes(".matricula")) {
          index = index.split(".matricula").join("")
          comissaoError[index].matricula = errorsValue[key][0]
        }
        if (index.includes(".unidade_lotacao")) {
          index = index.split(".unidade_lotacao").join("")
          comissaoError[index].unidade_lotacao = errorsValue[key][0]
        }
        if (index.includes(".nome")) {
          index = index.split(".nome").join("")
          comissaoError[index].nome = errorsValue[key][0]
        }
      } else {
        errorsState[key + "Error"] = errorsValue[key][0]
      }
    }
    errorsState.comissaoError = comissaoError
    this.setState(errorsState)
  }
  render() {
    if (this.state.httpError) {
      return (
        <div className="container-fluid">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    return (
      <div className="container-fluid">
        <LoadModalWithLabel
          label="Aguarde..."
          onClose={this.toggleLoadModal}
          show={this.state.showLoad}
        />
        <ComissaoItemModal
          itemID={this.state.editingItemID}
          callBack={this.reloadComissaoItem}
          show={this.state.showComissaoModal}
          onClose={this.toggleComissaoModal}
        />
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <div>
          {this.state.showForm === false && <Loading />}
          {this.state.showForm === true && (
            <div className="card card-plain">
              <div className="card-header" data-background-color="as-blue">
                <h4 className="title">
                  {this.props.isEditing
                    ? "Editar termo circunstanciado"
                    : "Criar termo circunstanciado"}
                </h4>
                <p className="category">
                  {this.props.isEditing
                    ? "Termo circunstanciado do contrato Nº : " +
                      this.state.num_contratoLabel
                    : "Criar novo termo circunstanciado"}
                </p>
              </div>
              <div className="card-content">
                <form>
                  <div className="row">
                    {!constants.userIsFiscal() && (
                      <SelectCustom
                        error={this.state.fiscal_idError}
                        sizeClass="col-md-4"
                        options={this.state.fiscais}
                        label="Selecione um fiscal"
                        name="fiscal"
                        value={this.state.fiscal}
                        onChange={this.onChangeFiscal}
                      />
                    )}
                  </div>
                  {this.state.contratos.length > 1 && (
                    <div>
                      <div className="row">
                        <SelectCustom
                          error={this.state.num_contratoError}
                          sizeClass="col-md-4"
                          options={this.state.contratos}
                          label={"Selecione um contrato"}
                          name={"contrato"}
                          value={this.state.contrato}
                          onChange={this.onChangeContrato}
                        />
                      </div>
                      <div className="row">
                        <InputCustom
                          type="checkbox"
                          sizeClass="col-md-2"
                          checked={!this.state.tipoComissao}
                          label="Gestor de contrato"
                          onChange={this.onChangeGestor}
                        />
                        <InputCustom
                          type="checkbox"
                          sizeClass="col-md-2"
                          checked={this.state.tipoComissao}
                          label="Comissão de contrato"
                          onChange={this.onChangeComissao}
                        />
                      </div>

                      {this.state.tipoComissao === true && (
                        <div className="card card-plain">
                          <div
                            className="card-header"
                            data-background-color="as-blue"
                          >
                            <h4 className="title">Comissão de contrato</h4>
                            <p className="category">Integrantes da comissão</p>
                          </div>
                          <div className="card-content">
                            {this.state.currentComissao.map(
                              (comissaoitem, key) => {
                                return (
                                  <div key={key} className="row card">
                                    <InputCustom
                                      type="text"
                                      disabled={true}
                                      sizeClass="col-md-2"
                                      value={comissaoitem.nome}
                                      label="Nome"
                                      onChange={event =>
                                        this.onChangeNome(event, key)
                                      }
                                    />
                                    <InputMaskCustom
                                      mask="999.999.999-99"
                                      disabled={true}
                                      sizeClass="col-md-2"
                                      label="CPF"
                                      type="text"
                                      onChange={event =>
                                        this.onChangeCPF(event, key)
                                      }
                                      value={comissaoitem.cpf}
                                    />
                                    <InputCustom
                                      type="text"
                                      disabled={true}
                                      sizeClass="col-md-2"
                                      value={comissaoitem.matricula}
                                      label="Matrícula"
                                      onChange={event =>
                                        this.onChangeMatricula(event, key)
                                      }
                                    />
                                    <InputCustom
                                      type="text"
                                      disabled={true}
                                      sizeClass="col-md-2"
                                      value={comissaoitem.unidade_lotacao}
                                      label="Unidade de lotação"
                                      onChange={event =>
                                        this.onChangeUnidadeLotacao(event, key)
                                      }
                                    />
                                    <button
                                      title="Remover"
                                      onClick={event =>
                                        this.removeComissao(
                                          event,
                                          key,
                                          comissaoitem.id
                                        )
                                      }
                                      className="btn btn-danger pull-left"
                                      data-background-color="red"
                                    >
                                      <i className="icon-header material-icons">
                                        delete
                                      </i>
                                    </button>
                                    <button
                                      title="Editar"
                                      onClick={event =>
                                        this.toggleComissaoModal(
                                          event,
                                          key,
                                          comissaoitem.id
                                        )
                                      }
                                      className="btn btn-danger pull-left"
                                      data-background-color="blue"
                                    >
                                      <i className="icon-header material-icons">
                                        create
                                      </i>
                                    </button>
                                  </div>
                                )
                              }
                            )}
                            {this.state.comissaoContrato.map(
                              (comissaoitem, key) => {
                                return (
                                  <div key={key} className="row card">
                                    <InputCustom
                                      type="text"
                                      error={this.state.comissaoError[key].nome}
                                      sizeClass="col-md-2"
                                      value={comissaoitem.nome}
                                      label="Nome"
                                      onChange={event =>
                                        this.onChangeNome(event, key)
                                      }
                                    />
                                    <InputMaskCustom
                                      mask="999.999.999-99"
                                      error={this.state.comissaoError[key].cpf}
                                      sizeClass="col-md-2"
                                      label="CPF"
                                      type="text"
                                      onChange={event =>
                                        this.onChangeCPF(event, key)
                                      }
                                      value={comissaoitem.cpf}
                                    />
                                    <InputCustom
                                      type="text"
                                      error={
                                        this.state.comissaoError[key].matricula
                                      }
                                      sizeClass="col-md-2"
                                      value={comissaoitem.matricula}
                                      label="Matrícula"
                                      onChange={event =>
                                        this.onChangeMatricula(event, key)
                                      }
                                    />
                                    <InputCustom
                                      type="text"
                                      error={
                                        this.state.comissaoError[key]
                                          .unidade_lotacao
                                      }
                                      sizeClass="col-md-2"
                                      value={comissaoitem.unidadeLotacao}
                                      label="Unidade de lotação"
                                      onChange={event =>
                                        this.onChangeUnidadeLotacao(event, key)
                                      }
                                    />
                                  </div>
                                )
                              }
                            )}
                            <div className="row">
                              <button
                                onClick={this.removeItem}
                                className="btn btn-danger pull-left"
                                data-background-color="red"
                              >
                                <i className="icon-header material-icons">
                                  remove
                                </i>
                              </button>
                              <button
                                onClick={this.addItem}
                                className="btn btn-primary pull-left"
                                data-background-color="green"
                              >
                                <i className="icon-header material-icons">
                                  add
                                </i>
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="row">
                        <TextArea
                          error={this.state.parecerError}
                          sizeClass="col-md-11"
                          rows="3"
                          subTitle=""
                          label="Parecer"
                          onChange={this.onChangeParecer}
                          value={this.state.parecer}
                        />
                      </div>
                      <div className="row">
                        <TextArea
                          error={this.state.ressalvaError}
                          sizeClass="col-md-11"
                          rows="3"
                          subTitle=""
                          label="Ressalva"
                          onChange={this.onChangeRessalva}
                          value={this.state.ressalva}
                        />
                      </div>
                      <button
                        onClick={this.sendForm}
                        className="btn btn-primary pull-right"
                        data-background-color="as-blue"
                      >
                        Enviar
                      </button>
                    </div>
                  )}
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}
export default withRouter(TermoCircunstanciadoForm)



// WEBPACK FOOTER //
// ./src/views/modais/TermoCircunstanciadoForm.js